export { v4 as uuid } from 'uuid';
import { Md5 } from 'ts-md5';
// SINGLETON ALERT!
let _isLocalhostEnvironment;
// SINGLETON ALERT!
let _isTestEnvironment;
// the built-in decodeURIComponent() function needs an additional step to handle + signs -> spaces
// TODO: See if a urlEncode version of this needs a custom implementation too.
export function urlDecode(str) {
    return decodeURIComponent(str.replace(/\+/g, ' '));
}
// Adapted from https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore to avoid lodash.
export function range(length) {
    return Array.from({ length }, (_, i) => i);
}
export function isTestEnvironment() {
    if (_isTestEnvironment === undefined) {
        const params = new URLSearchParams(window.location.search);
        _isTestEnvironment = params.has('test');
    }
    return _isTestEnvironment;
}
export function isLocalhostEnvironment() {
    if (_isLocalhostEnvironment === undefined) {
        _isLocalhostEnvironment = window.location.href.toLowerCase().includes('localhost');
    }
    return _isLocalhostEnvironment;
}
export function getAutoLoginPrefixFromUrl() {
    if (!isLocalhostEnvironment()) {
        return '';
    }
    const params = new URLSearchParams(window.location.search);
    return params.get('autoLoginPrefix') || '';
}
export function getPrefillUsernameFromUrl(instanceId) {
    if (!isLocalhostEnvironment()) {
        return '';
    }
    const params = new URLSearchParams(window.location.search);
    const prefillUsernamesString = params.get('prefillUsernames');
    if (prefillUsernamesString) {
        return prefillUsernamesString.split(',')[instanceId];
    }
    return '';
}
export function getPrefillPasswordFromUrl(instanceId) {
    if (!isLocalhostEnvironment()) {
        return '';
    }
    const params = new URLSearchParams(window.location.search);
    const prefillPasswordsString = params.get('prefillPasswords');
    if (prefillPasswordsString) {
        return prefillPasswordsString.split(',')[instanceId];
    }
    return '';
}
export function getPrefillEmailFromUrl(instanceId) {
    if (!isLocalhostEnvironment()) {
        return '';
    }
    const params = new URLSearchParams(window.location.search);
    const prefillEmailsString = params.get('prefillEmails');
    if (prefillEmailsString) {
        return prefillEmailsString.split(',')[instanceId];
    }
    return '';
}
export function getTopWindow() {
    return window.top || window;
}
export function delay(ms) {
    return new Promise((resolve) => {
        setTimeout(resolve, ms);
    });
}
export function md5(input) {
    return Md5.hashStr(input);
}
export function isDebugPanelEnabled() {
    const params = new URLSearchParams(window.location.search);
    return params.has('debug');
}
export function getBooleanString(value) {
    if (value === undefined) {
        return 'UNDEFINED';
    }
    return new Boolean(value).toString().toUpperCase();
}
export function isPageVisible() {
    return document.visibilityState === 'visible';
}
export function getOnOffBooleanLabel(isOn) {
    return isOn ? 'On' : 'Off';
}
